<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button [disabled]="listaPlazosPeriodo && esPeriodoFinalizado" class="btn btn-outline-success" type="button" (click)="onAdd($event)" title="Añadir Plazo">
            <i class="fa fa-file-o"></i> Nuevo Plazo
        </button>
        <div *ngIf="listaPlazosPeriodo && esPeriodoFinalizado" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo finalizado</label>
        </div>        
    </form>
</nav>

<div class="container-fluid container-list">
    <app-plazos-list *ngIf="searching" [listaPlazosPeriodo]="listaPlazosPeriodo" [esPeriodoFinalizado]="esPeriodoFinalizado" (editEmitter)="onEdit($event)" (deleteEmitter)="onDelete($event)"></app-plazos-list>
</div>

